import { render } from "./TestWebhookDeliveryView.vue?vue&type=template&id=dfacb720&scoped=true"
import script from "./TestWebhookDeliveryView.vue?vue&type=script&lang=js"
export * from "./TestWebhookDeliveryView.vue?vue&type=script&lang=js"

import "./TestWebhookDeliveryView.vue?vue&type=style&index=0&id=dfacb720&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfacb720"]])

export default __exports__